"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FulfillmentCalculateResponseSchema = exports.FulfillmentCandidateSchema = exports.FulfillmentCalculateRequestSchema = exports.FulfillmentAddressSchema = exports.FulfillmentMethodSchema = void 0;
const zod_1 = require("zod");
exports.FulfillmentMethodSchema = zod_1.z.enum(['local-delivery', 'shipping', 'pickup']);
// Customer address as supplied by the SPA at checkout (lat/lon optional — geocoder fills them in).
exports.FulfillmentAddressSchema = zod_1.z.object({
    street: zod_1.z.string().min(1),
    city: zod_1.z.string().min(1),
    state: zod_1.z.string().min(1),
    zip: zod_1.z.string().min(1),
    country: zod_1.z.string().min(1).default('US'),
    lat: zod_1.z.number().optional(),
    lon: zod_1.z.number().optional(),
});
exports.FulfillmentCalculateRequestSchema = zod_1.z.object({
    mode: zod_1.z.enum(['own-site', 'marketplace']),
    tenantId: zod_1.z.string().optional(), // required when mode === 'own-site'
    marketplaceId: zod_1.z.string().optional(), // required when mode === 'marketplace'
    variantIds: zod_1.z.array(zod_1.z.string()).min(1),
    customerAddress: exports.FulfillmentAddressSchema,
    fulfillmentPreference: zod_1.z.enum(['delivery', 'pickup', 'any']).default('any'),
    // Cart subtotal (pre-fee), used by the router's freeOverAmount/freeOver pricing-mode
    // thresholds (Task 6). Optional/additive — absent defaults to 0 in the handler, so
    // existing callers that don't send it are unaffected.
    subtotal: zod_1.z.number().nonnegative().optional(),
}).superRefine((val, ctx) => {
    if (val.mode === 'own-site' && !val.tenantId) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'tenantId required for own-site', path: ['tenantId'] });
    }
    if (val.mode === 'marketplace' && !val.marketplaceId) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'marketplaceId required for marketplace', path: ['marketplaceId'] });
    }
});
exports.FulfillmentCandidateSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    method: exports.FulfillmentMethodSchema,
    fee: zod_1.z.number().nonnegative(),
    estimatedMinutes: zod_1.z.number().nonnegative(),
    distanceKm: zod_1.z.number().nonnegative(),
    doorDashEnabled: zod_1.z.boolean().default(false),
    reason: zod_1.z.string().optional(), // marketplace alternatives only ('higher rated', 'ships nationwide', ...)
});
exports.FulfillmentCalculateResponseSchema = zod_1.z.object({
    recommended: exports.FulfillmentCandidateSchema.nullable(),
    alternatives: zod_1.z.array(exports.FulfillmentCandidateSchema),
});
//# sourceMappingURL=fulfillment-quote.schema.js.map